export const SET_ADMIN_DATA = 'SET_ADMIN_DATA';


export function setUserDataAction(admin) {
  return {
    type: SET_ADMIN_DATA,
    payload: admin,
  };
}
